import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, keyframes } from 'styled-components';
import BarsLoader from '../../Elements/BarsLoader';
import { Media } from '../../theme/Media';
import { Tooltip } from '../../V2/Feedback/Tooltip';
import { useTableContext } from './context';
const Title = styled.div `
  font-size: 12px;
  line-height: 1.1;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 -7px;
  padding: 0 5px 3px;
  width: ${({ width }) => width || 84}px;
  white-space: ${({ $nowrap }) => $nowrap && 'nowrap'};
`;
const Icon = styled.div `
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media ${({ isCollapsedNav }) => (isCollapsedNav ? Media.lgMin : Media.xlgMin)} {
    margin: 0 auto;
  }
`;
const fadeIn = (width) => keyframes `
    0% {
      width: 0;
    }
    100% {
      width: ${width}px;
    }
  `;
const fadeInXs = () => keyframes `
    0% {
      height: 0;
    }
    100% {
      height: 40px;
    }
  `;
const Wrapper = styled.button `
  height: 100%;
  width: ${({ width }) => width || 84}px;
  border: none;
  box-shadow: none;
  outline: none;
  padding: 0;
  color: ${({ theme }) => theme.colors.grey00_2};
  animation: ${({ width }) => fadeIn(width || 84)} 0.3s ease-out;
  background: ${({ remove, theme }) => remove ? theme.colors.critical100 : theme.themeId === 'primaryDark' ? theme.colors.grey00_1 : theme.colors.black_1};
  position: relative;
  transition: opacity 0.16s;
  overflow: hidden;
  @media ${({ isCollapsedNav }) => (isCollapsedNav ? Media.mdMax : Media.lgMax)} {
    display: flex;
    padding: 8px 10px;
    height: 0;
    min-width: 120px;
    width: auto;
    animation: ${fadeInXs} 0.4s cubic-bezier(0.07, 0.9, 0.32, 1.28);
    animation-fill-mode: forwards;
  }
  svg path {
    ${({ iconType, theme }) => `${iconType}: ${theme.colors.grey00_2};`};
  }
  &[disabled] {
    cursor: not-allowed;
    > * {
      opacity: 0.3;
    }
  }
`;
const ActionsListItem = ({ tooltip, remove, width, onClick, children, icon, id, dataTestId, disabled = false, isLoading = false, iconType = 'stroke', className, $nowrap, }) => {
    const { isCollapsedNav } = useTableContext();
    return tooltip ? (_jsx(Tooltip, { placement: 'top', tooltip: tooltip, children: _jsxs(Wrapper, { id: id, onClick: onClick, width: width, remove: remove, "data-testid": dataTestId, disabled: disabled, iconType: iconType, isCollapsedNav: isCollapsedNav, className: className, children: [icon && _jsx(Icon, { isCollapsedNav: isCollapsedNav, children: isLoading ? _jsx(BarsLoader, {}) : icon }), _jsx(Title, { width: width, "$nowrap": $nowrap, children: children })] }) })) : (_jsxs(Wrapper, { id: id, onClick: onClick, width: width, remove: remove, "data-testid": dataTestId, disabled: disabled, iconType: iconType, isCollapsedNav: isCollapsedNav, className: className, children: [_jsx(Icon, { isCollapsedNav: isCollapsedNav, children: isLoading ? _jsx(BarsLoader, {}) : icon }), _jsx(Title, { width: width, "$nowrap": $nowrap, children: children })] }));
};
export default ActionsListItem;
